import { DemandStatus } from '../../../../Enums/demand-status.enum';
import { Permissions } from '../../../../Enums/permission.enum';
import { ReportSubjectTab } from '../Types/report-subject-tab.type';

export const REPORT_TAB_LABEL_KEY_MAP: Record<ReportSubjectTab, string> = {
  application: 'app.reports.allDemands.tabs.applications',
  group: 'app.reports.allDemands.tabs.groups',
};

export const REPORT_TAB_PERMISSIONS: Record<ReportSubjectTab, Permissions[]> = {
  application: [
    Permissions.APPLICATION_MANAGER,
    Permissions.APPLICATION_MODERATOR,
    Permissions.REPORT_MANAGER,
  ],
  group: [Permissions.GROUP_MANAGER, Permissions.GROUP_MODERATOR, Permissions.REPORT_MANAGER],
};

export const REPORT_ROUTE_PERMISSIONS: Permissions[] = [
  ...REPORT_TAB_PERMISSIONS.application,
  ...REPORT_TAB_PERMISSIONS.group,
];

export const REPORT_ACTIVE_STATUSES: ReadonlySet<DemandStatus> = new Set([
  DemandStatus.Pending,
  DemandStatus.Ongoing,
]);

export const ALL_DEMANDS_DISPLAYED_COLUMNS = [
  'subject',
  'reference',
  'requester',
  'status',
  'progress',
  'requested',
  'lastUpdate',
  'actions',
];

export const ALL_DEMANDS_SKELETON_COLUMN_WIDTHS = [1.5, 0.8, 1.2, 0.7, 0.8, 0.7, 0.7, 0.8];

export const ALL_DEMANDS_LIST_ROUTE = '/reports/all-demands';
